import api, { Method } from 'src/utils/apiManager.utils';
import { apiUrls } from 'src/utils/properties';

const updateParent = async (data: Object) => {
  return new Promise((resolve, reject) => {
    api(
      Method.PUT,
      { 'Content-Type': 'multipart/form-data' },
      apiUrls.PARENT,
      '',
      data,
      ''
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getParentById = async () => {
  return new Promise((resolve, reject) => {
    api(Method.GET, null, apiUrls.PARENT + apiUrls.GET_PARENT_BY_ID, '', '', '')
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getStudentsByParentId = async () => {
  return new Promise((resolve, reject) => {
    api(Method.GET, null, apiUrls.PARENT + apiUrls.LIST_STUDENT, '', '', '')
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const updateStudentByParent = async (data: Object) => {
  return new Promise((resolve, reject) => {
    api(
      Method.PUT,
      { 'Content-Type': 'multipart/form-data' },
      apiUrls.STUDENT_RECORD,
      '',
      data,
      ''
    )
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const createStudent = async (data: Object) => {
  return new Promise((resolve, reject) => {
    api(Method.POST, null, apiUrls.STUDENT, '', data, '')
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getPaymentDetails = async () => {
  return new Promise((resolve, reject) => {
    api(Method.GET, null, apiUrls.PARENT + apiUrls.PAYMENT_DETAILS)
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getSessions = async () => {
  return new Promise((resolve, reject) => {
    api(Method.GET, null, apiUrls.PARENT + apiUrls.GET_SESSIONS)
      .then((response: any) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export {
  updateParent,
  getStudentsByParentId,
  getParentById,
  updateStudentByParent,
  createStudent,
  getPaymentDetails,
  getSessions
};
